(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-curling-house"] && !Shopify.designMode) return;
  try {
    
  /** Thumbnail strip for the House gallery. Swaps the hero image only. */
  class TfCurlingGallery extends HTMLElement {
    connectedCallback() {
      this.hero = this.querySelector('[data-tf-hero]');
      this.thumbs = Array.from(this.querySelectorAll('[data-tf-thumb]'));
      if (!this.hero || !this.thumbs.length) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.hero.removeAttribute('srcset');
          this.hero.src = thumb.dataset.full;
          this.hero.alt = thumb.dataset.alt || '';
          this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    }
  }

  if (!customElements.get('tf-curling-gallery')) {
    customElements.define('tf-curling-gallery', TfCurlingGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-curling-sheet"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drag-to-choose for the Sheet page.
   *
   * Deliberately thin: it only moves the stone and, on release, clicks the
   * nearest zone. All pricing state stays in the shared tf-curling-offer
   * element, so the plain tier list, the zones and the drag can never
   * disagree with each other.
   */
  class TfCurlingSheetThrow extends HTMLElement {
    connectedCallback() {
      this.stone = this.querySelector('[data-tf-stone]');
      this.zones = Array.from(this.querySelectorAll('[data-tf-zone-at]'));
      if (!this.stone || !this.zones.length) return;

      this.dragging = false;
      this.settle();

      this.stone.addEventListener('pointerdown', (event) => {
        this.dragging = true;
        this.stone.classList.add('is-dragging');
        this.stone.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      this.stone.addEventListener('pointermove', (event) => {
        if (!this.dragging) return;
        this.stone.style.left = `${this.percentFrom(event)}%`;
      });

      this.stone.addEventListener('pointerup', (event) => {
        if (!this.dragging) return;
        this.dragging = false;
        this.stone.classList.remove('is-dragging');
        this.nearestZone(this.percentFrom(event)).click();
      });

      this.stone.addEventListener('pointercancel', () => {
        this.dragging = false;
        this.stone.classList.remove('is-dragging');
        this.settle();
      });

      this.stone.addEventListener('keydown', (event) => {
        const index = this.zones.findIndex((z) => z.classList.contains('is-tf-selected'));
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = Math.min(this.zones.length - 1, index + 1);
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = Math.max(0, index - 1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.zones.length - 1;
        else return;
        event.preventDefault();
        this.zones[next].click();
      });

      // The offer element owns the state; follow whatever it settles on.
      const offer = this.closest('tf-curling-offer');
      if (offer) {
        offer.addEventListener('tf-offer:change', (event) => {
          this.settle();
          const sets = event.detail && event.detail.sets;
          if (sets) this.stone.setAttribute('aria-valuenow', String(sets));
        });
      }
    }

    percentFrom(event) {
      const box = this.getBoundingClientRect();
      const raw = ((event.clientX - box.left) / box.width) * 100;
      return Math.max(4, Math.min(96, raw));
    }

    nearestZone(percent) {
      let best = this.zones[0];
      let bestGap = Infinity;
      this.zones.forEach((zone) => {
        const gap = Math.abs(parseFloat(zone.dataset.tfZoneAt) - percent);
        if (gap < bestGap) {
          bestGap = gap;
          best = zone;
        }
      });
      return best;
    }

    settle() {
      if (this.dragging) return;
      const active = this.zones.find((z) => z.classList.contains('is-tf-selected')) || this.zones[0];
      this.stone.style.left = `${active.dataset.tfZoneAt}%`;
    }
  }

  if (!customElements.get('tf-curling-sheet-throw')) {
    customElements.define('tf-curling-sheet-throw', TfCurlingSheetThrow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-jersey-configurator"] && !Shopify.designMode) return;
  try {
    
  class TfJerseyConfigurator extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-jc-chip]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-jc-thumb]'));
      this.slides = Array.from(this.querySelectorAll('[data-jc-slide]'));
      this.variantInput = this.querySelector('[data-jc-variant-id]');
      this.priceEl = this.querySelector('[data-jc-price]');
      this.addButton = this.querySelector('button[name="add"]');
      this.prompt = this.querySelector('[data-jc-prompt]');

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          if (chip.getAttribute('aria-disabled') === 'true') return;
          this.selectVariant(chip);
        });
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId));
      });

      // Honor a deep-linked variant; otherwise start neutral with no country
      // chosen — the main image shows and add-to-cart stays gated.
      const active = this.chips.find((c) => c.classList.contains('is-active'));
      if (active) {
        this.selectVariant(active, true);
      } else if (this.addButton) {
        this.addButton.disabled = true;
        if (this.prompt) this.prompt.hidden = false;
      }
    }

    selectVariant(chip, isInit) {
      this.chips.forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      const { variantId, price, available, mediaId } = chip.dataset;

      if (this.variantInput && variantId) this.variantInput.value = variantId;
      if (this.priceEl && price) this.priceEl.textContent = price;

      // A country is now chosen — hide the prompt, enable add-to-cart unless sold out.
      if (this.prompt) this.prompt.hidden = true;
      if (this.addButton) this.addButton.disabled = available === 'false';

      // Show the slide tied to this country (skip animation on first paint).
      if (mediaId) this.showMedia(mediaId, isInit);
    }

    showMedia(mediaId, isInit) {
      if (!mediaId) return;

      this.slides.forEach((slide) => {
        const on = slide.dataset.mediaId === mediaId;
        if (on === !slide.hasAttribute('hidden')) {
          if (!on) this.#pauseSlide(slide);
          return;
        }
        slide.toggleAttribute('hidden', !on);
        slide.classList.toggle('is-active', on);
        if (isInit) slide.style.animation = 'none';
        if (!on) this.#pauseSlide(slide);
      });

      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }

    #pauseSlide(slide) {
      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
    }
  }

  if (!customElements.get('tf-jersey-configurator')) {
    customElements.define('tf-jersey-configurator', TfJerseyConfigurator);
  }

  } catch(e) { console.error(e); }
})();
})();
